'use strict';

module.exports = {
    pushEvent: function () {
        $('.hero-banner__text').on('click', function() {
            pushHomepageEventToDataLayer($('.hero-banner__label').html().trim().toLowerCase(), $('#hero-banner__title').html().trim().toLowerCase());
        });

        $('.cacio-pepe .js-pd-button').on('click', function() {
            pushHomepageEventToDataLayer($(this).html().trim().toLowerCase(), $('.cacio-pepe__title').html().trim().toLowerCase());
        });

        $('.product-grid-section.tiles-4 .js-pd-button').on('click', function() {
            pushHomepageEventToDataLayer($(this).html().trim().toLowerCase(), $('.product-grid-section.tiles-4 .section-title').html().trim().toLowerCase());
        });

        $('.product-grid-section.tiles-2 .js-pd-button').on('click', function() {
            pushHomepageEventToDataLayer($(this).html().trim().toLowerCase(), $('.product-grid-section.tiles-2 .section-title').html().trim().toLowerCase());
        });

        $('.artistic-section .js-pd-button').on('click', function() {
            pushHomepageEventToDataLayer($(this).html().trim().toLowerCase(), $('.artistic-section__title').html().trim().toLowerCase());
        });
    }
};

/**
 * @function pushHomepageEventToDataLayer
 * @description Push 'home_cta_click' event in the Datalayer
 * @param {String} ctaName name of the CTA clicked
 * @param {String} ctaType name of the section of the CTA
 **/
function pushHomepageEventToDataLayer(ctaName, ctaType) {
    dataLayer.push({
        'event': 'home_cta_click',
        'ctaName': ctaName,
        'ctaType': ctaType
    });
}

